export const demoDe = {
  // ── DemoPage: Seo ──────────────────────────────────────────────────────────
  'demo.seoTitle': 'Jetzt spielen — Betritt Grymwyrd',
  'demo.seoDescription':
    'Lass die Welt sich drehen, ergattere einen Platz am Tisch, schmiede einen Grymwyrd-Helden und wirf die Knochen — eine geführte Tour durch den virtuellen Spieltisch von Grymwyrd.',

  // ── DemoPage: GlobeStep ─────────────────────────────────────────────────────
  'demo.globe.worldAriaLabel': 'Die Welt von Grymwyrd',
  'demo.globe.spinningWorld': 'Die Welt dreht sich…',
  'demo.globe.tagline': 'Eine lebendige Horror-Fantasy-Welt',
  'demo.globe.arrivedHeading': 'Region Greywick',
  'demo.globe.heading': 'Finde deinen Platz im ewigen Zwielicht',
  'demo.globe.subheading': 'Im Herzen der Welt wartet ein Tisch auf dich. Nimm Platz und schmiede einen Helden.',
  'demo.globe.enterCta': 'Hinab nach Grymwyrd',

  // ── DemoPage: AccountStep ───────────────────────────────────────────────────
  'demo.account.heading': 'Werde Teil der Geschichte',
  'demo.account.subheading':
    'Erstelle ein kostenloses Konto, um die vollständige Grymwyrd-Enzyklopädie freizuschalten und den Helden zu speichern, den du gleich schmiedest — oder tritt als Gast ein und erkunde sofort.',
  'demo.account.createAccount': 'Konto erstellen',
  'demo.account.logIn': 'Anmelden',
  'demo.account.continueAsGuest': 'Als Gast fortfahren',

  // ── DemoPage: CreateStep ────────────────────────────────────────────────────
  'demo.create.abilityRollLabel': '{ability} (3W6)',
  'demo.create.initiativeLabel': 'Initiative',
  'demo.create.lobbyEyebrow': 'Virtueller Spieltisch von Grymwyrd · Lobby',
  'demo.create.heading': 'Schmiede deinen Helden',
  'demo.create.subheading': 'Ein SRD-5.2.1-Charakter, ein Kind Grymwyrds. Gib ihm einen Namen, wähle eine Berufung und wirf die Knochen.',
  'demo.create.nameLabel': 'Name',
  'demo.create.namePlaceholder': 'Wer soll daraus werden?',
  'demo.create.chooseCalling': 'Wähle deine Berufung',
  'demo.create.keyAbility': 'Schlüsselattribut: {ability}',
  'demo.create.abilityScores': 'Attributswerte',
  'demo.create.abilityScoresHint': '— zum Würfeln von 3W6 klicken',
  'demo.create.rollAbilityAria': '{ability} würfeln (3W6)',
  'demo.create.keepStandard': 'Oder behalte die Standardwerte von 10 und leg einfach los.',
  'demo.create.initiativeResult': 'Initiative {initiative} — wirf die Knochen, der Tisch wendet sich dir zu…',
  'demo.create.bonesTumble': 'Die Knochen rollen…',
  'demo.create.rollInitiativeCta': 'Auf Initiative würfeln & Platz nehmen',
  'demo.create.chooseCallingHint': 'Wähle eine Berufung, um deinen Platz einzunehmen.',

  // ── DemoTableStep ───────────────────────────────────────────────────────────
  'demo.table.errorHeading': 'Der Tisch konnte nicht gedeckt werden',
  'demo.table.errorBody': 'Der Spieltisch ist gerade nicht verfügbar.',
  'demo.table.browseLiveTables': 'Stattdessen Live-Tische durchsuchen',
  'demo.table.settingTable': 'Dein Tisch wird gedeckt…',
  'demo.table.connecting': 'Verbindung zum Spieltisch wird hergestellt…',
  'demo.table.heroTable': 'Tisch von {name}',
  'demo.table.firstTable': 'Dein erster Tisch',
  'demo.table.diceTrayHeading': 'Würfelschale',
  'demo.table.initiativeHeading': 'Initiative',
  'demo.table.initiativePrompt': 'Wirf die Knochen, um die Kampfreihenfolge festzulegen.',
  'demo.table.rollForInitiative': 'Auf Initiative würfeln',
  'demo.table.vttEyebrow': 'Grymwyrd VTT',
  'demo.table.xcardTitle': 'Das Spiel pausieren, anonym',
  'demo.table.xcard': 'X-Card',
  'demo.table.saveHeroTitle': 'Erstelle ein kostenloses Konto, um deinen Helden zu speichern',
  'demo.table.saveHero': 'Helden speichern',
  'demo.table.statusLive': 'Live',
  'demo.table.statusConnecting': 'Verbindung…',
  'demo.table.actionLogHeading': 'Aktionsprotokoll',
  'demo.table.recentRollsHeading': 'Letzte Würfe',

  // ── DemoTableStep: dock panel titles ────────────────────────────────────────
  'demo.panel.heroSheet': 'Heldenbogen',
  'demo.panel.companion': 'Begleiter',
  'demo.panel.diceTray': 'Würfelschale',
  'demo.panel.macros': 'Makros',
  'demo.panel.diceConsole': 'Würfelkonsole',
  'demo.panel.initiative': 'Initiative',
  'demo.panel.poll': 'Umfrage',
  'demo.panel.recentRolls': 'Letzte Würfe',
  'demo.panel.reference': 'Nachschlagewerk',
  'demo.panel.chat': 'Chat',
  'demo.panel.handouts': 'Handouts',
  'demo.panel.safety': 'Sicherheit',
  'demo.panel.sceneAndCues': 'Szene & Stichworte',
  'demo.panel.replay': 'Wiederholung',
  'demo.panel.recap': 'Zusammenfassung',
  'demo.panel.actionLog': 'Aktionsprotokoll',

  // ── DemoTableStep: ActionBar ────────────────────────────────────────────────
  'demo.action.melee': 'Nahkampf',
  'demo.action.cast': 'Zaubern',
  'demo.action.move': 'Bewegen',
  'demo.action.block': 'Blocken',
  'demo.action.chooseTarget': 'Wähle ein Ziel für {action}…',
  'demo.action.controlling': 'Steuerung:',
  'demo.action.cannotAct': '{label} kann nicht handeln — wähle einen Mob, Spieler, ein Fahrzeug oder einen NSC.',
  'demo.action.selectActionable': 'Wähle ein handlungsfähiges Objekt, um damit zu agieren.',
  'demo.action.cancel': 'Abbrechen',

  // ── DemoTableStep: InitiativeTracker ────────────────────────────────────────
  'demo.tracker.rollingOrder': 'Reihenfolge wird ausgewürfelt…',
  'demo.tracker.combatant': 'Kämpfer {n}',
  'demo.tracker.previousTurn': 'Vorheriger Zug',
  'demo.tracker.round': 'Runde {round}',
  'demo.tracker.endCombatTitle': 'Kampf beenden',
  'demo.tracker.end': 'Beenden',
  'demo.tracker.nextTurnTitle': 'Nächster Zug',
  'demo.tracker.next': 'Weiter',
  'demo.tracker.hitPoints': 'Trefferpunkte',
  'demo.tracker.reduceHp': 'TP von {name} senken',
  'demo.tracker.raiseHp': 'TP von {name} erhöhen',
  'demo.tracker.addStatusEffect': 'Statuseffekt hinzufügen',
  'demo.tracker.removeFromOrder': 'Aus der Reihenfolge entfernen',
  'demo.tracker.removeFromOrderTitle': 'Aus der Reihenfolge entfernen',
  'demo.tracker.removeCondition': '{name} entfernen',
  'demo.tracker.roundsShort': '{n}R',

  // ── DemoTableStep: XCardOverlay ─────────────────────────────────────────────
  'demo.xcard.ariaLabel': 'Der Tisch ist pausiert',
  'demo.xcard.heading': 'Der Tisch ist pausiert',
  'demo.xcard.body':
    'Jemand hat die X-Card gezogen. Wir pausieren — ohne Fragen und ohne Namen zu nennen. Wenn alle bereit sind, geht es weiter.',
  'demo.xcard.resume': 'Wir sind bereit — weiter',

  // ── DemoTableStep: HandoutsCard ─────────────────────────────────────────────
  'demo.handouts.heading': 'Handouts',
  'demo.handouts.titlePlaceholder': 'Titel (optional)',
  'demo.handouts.bodyPlaceholder': 'Eine Notiz, ein Hinweis, ein Vorlesetext…',
  'demo.handouts.push': 'An den Tisch senden',
  'demo.handouts.whispered': 'Geflüstert',
  'demo.handouts.dismiss': 'Handout schließen',

  // ── DemoTableStep: SafetyCard / SafetyList ──────────────────────────────────
  'demo.safety.heading': 'Sicherheit',
  'demo.safety.description': 'Grenzen, die wir nicht überschreiten; Schleier, die wir ziehen. Vom ganzen Tisch geteilt, niemals zugeordnet.',
  'demo.safety.linesLabel': 'Grenzen (klares Nein)',
  'demo.safety.veilsLabel': 'Schleier (Schnitt ins Schwarze)',
  'demo.safety.removeItem': '„{item}“ entfernen',
  'demo.safety.addLinePlaceholder': 'Grenze hinzufügen…',
  'demo.safety.addVeilPlaceholder': 'Schleier hinzufügen…',
  'demo.safety.addLine': 'Grenze hinzufügen',
  'demo.safety.addVeil': 'Schleier hinzufügen',

  // ── DemoTableStep: CharacterSheetPanel ──────────────────────────────────────
  'demo.sheet.heading': 'Heldenbogen',
  'demo.sheet.hp': 'TP',
  'demo.sheet.ac': 'RK',
  'demo.sheet.classLevel': '{className} · Stufe 1',

  // ── CompanionPanel ──────────────────────────────────────────────────────────
  'demo.companion.heading': 'Begleitgerät',
  'demo.companion.description':
    'Koppele ein Smartphone oder Tablet als schreibgeschützten Zweitbildschirm — Initiative, letzte Würfe und die Szene werden auf das Gerät gespiegelt. Jederzeit widerrufbar.',
  'demo.companion.pairDevice': 'Gerät koppeln',
  'demo.companion.qrAriaLabel': 'QR-Code zum Koppeln des Begleitgeräts',
  'demo.companion.copied': 'Kopiert',
  'demo.companion.copyLink': 'Link kopieren',
  'demo.companion.revoke': 'Widerrufen',

  // ── MacroTray ───────────────────────────────────────────────────────────────
  'demo.macros.heading': 'Würfelmakros',
  'demo.macros.dismissError': 'Fehler schließen',
  'demo.macros.newMacro': 'Neues Makro',
  'demo.macros.namePlaceholder': 'Name (keine Punkte)',
  'demo.macros.labelPlaceholder': 'Schaltflächentext (optional)',
  'demo.macros.save': 'Makro speichern',
  'demo.macros.noDots': 'Makronamen dürfen keine Punkte enthalten.',

  // ── PollBoard ───────────────────────────────────────────────────────────────
  'demo.poll.heading': 'Umfrage',
  'demo.poll.questionPlaceholder': 'Frag den Tisch…',
  'demo.poll.optionPlaceholder': 'Option {n}',
  'demo.poll.removeOption': 'Option {n} entfernen',
  'demo.poll.addOption': 'Option hinzufügen',
  'demo.poll.openPoll': 'Umfrage öffnen',
  'demo.poll.live': 'Live',
  'demo.poll.closed': 'Umfrage geschlossen',
  'demo.poll.vote': 'Abstimmen',
  'demo.poll.closePoll': 'Umfrage schließen',
  'demo.poll.startNewPoll': 'Neue Umfrage starten',

  // ── RecapCard ───────────────────────────────────────────────────────────────
  'demo.recap.heading': 'Sitzungszusammenfassung',
  'demo.recap.tagline': 'Die Geschichte deines Tisches, wenn sich der Staub gelegt hat.',
  'demo.recap.gathering': 'Die Geschichte wird zusammengetragen…',
  'demo.recap.getRecap': 'Sitzungszusammenfassung abrufen',
  'demo.recap.notableRolls': 'Bemerkenswerte Würfe',
  'demo.recap.copied': 'Kopiert!',
  'demo.recap.share': 'Teilen',

  // ── ReferenceCard / ReferenceDetail ─────────────────────────────────────────
  'demo.reference.heading': 'Nachschlagewerk',
  'demo.reference.searchPlaceholder': 'Ein Monster, einen Zauber, eine Regel nachschlagen…',
  'demo.reference.searchAria': 'Die Enzyklopädie durchsuchen, um etwas zu teilen',
  'demo.reference.typeToSearch': 'Gib mindestens zwei Buchstaben ein, um die lebendige Enzyklopädie zu durchsuchen.',
  'demo.reference.searching': 'Suche läuft…',
  'demo.reference.open': '{title} öffnen',
  'demo.reference.share': 'Teilen',
  'demo.reference.dismiss': 'Nachschlagewerk schließen',
  'demo.reference.backToSearch': 'Zurück zur Suche',
  'demo.reference.loadingContent': 'Inhalt wird geladen…',
  'demo.reference.notOwned':
    'Du besitzt dieses Buch noch nicht. Das vollständige Nachschlagewerk wird freigeschaltet, sobald du es deiner Bibliothek hinzufügst.',
  'demo.reference.contentDown': 'Der Inhalt ist gerade nicht verfügbar. Versuche es gleich noch einmal.',
  'demo.reference.noAdditionalContent': 'Kein zusätzlicher Inhalt für dieses Nachschlagewerk.',
  'demo.reference.noLinkedContent': 'Kein verknüpfter Buchinhalt für dieses Nachschlagewerk.',
  'demo.reference.shareToTable': 'Mit dem Tisch teilen',

  // ── ReplayTimeline ──────────────────────────────────────────────────────────
  'demo.replay.heading': 'Wiederholung',
  'demo.replay.tagline': 'Geh die Sitzung Moment für Moment noch einmal durch.',
  'demo.replay.loading': 'Wird geladen…',
  'demo.replay.loadReplay': 'Wiederholung laden',
  'demo.replay.loadMore': 'Mehr laden',

  // ── RollFeed / VisibilityToggle ─────────────────────────────────────────────
  'demo.dice.heading': 'Würfel',
  'demo.dice.dismissError': 'Fehler schließen',
  'demo.dice.labelPlaceholder': 'Angriff (optional)',
  'demo.dice.roll': 'Würfeln',
  'demo.dice.rolledForReal': 'Ich habe wirklich gewürfelt',
  'demo.dice.totalPlaceholder': 'Summe (erforderlich)',
  'demo.dice.physNotationPlaceholder': '1W20+5 (optional)',
  'demo.dice.physLabelPlaceholder': 'Bezeichnung (optional)',
  'demo.dice.logPhysical': 'Echten Wurf eintragen',
  'demo.dice.onTable': '🎲 am Tisch',
  'demo.dice.private': 'Privat',
  'demo.dice.public': 'Öffentlich',
  'demo.dice.rolledPrivately': 'privat gewürfelt',
  'demo.dice.exploded': 'explodiert',

  // ── SceneBoard ──────────────────────────────────────────────────────────────
  'demo.scene.heading': 'Szene & Stichworte',
  'demo.scene.current': 'Szene: {scene}',
  'demo.scene.cueSuffix': '— Stichwort: {cue}',
  'demo.scene.noScene': 'Keine Szene festgelegt',
  'demo.scene.oneShotCues': 'Einmalige Stichworte',

  // ── TableMap ────────────────────────────────────────────────────────────────
  'demo.map.tokenAt': '{label} bei {x},{y}',
  'demo.map.tile': 'Feld {x},{y}',
  'demo.map.fogged': 'Vernebelt',
  'demo.map.battleMap': 'Kampfkarte',
  'demo.map.gm': 'SL',
  'demo.map.noMap': 'Keine Karte',
  'demo.map.uploadedMap': 'Hochgeladene Karte',
  'demo.map.uploadTitle': 'Lade ein Kartenbild als Hintergrund der Leinwand hoch',
  'demo.map.reading': 'Wird gelesen…',
  'demo.map.upload': 'Hochladen',
  'demo.map.size': 'Größe',
  'demo.map.shrinkMap': 'Karte verkleinern',
  'demo.map.growMap': 'Karte vergrößern',
  'demo.map.widthShort': 'B',
  'demo.map.narrowMap': 'Karte schmaler machen',
  'demo.map.widenMap': 'Karte breiter machen',
  'demo.map.heightShort': 'H',
  'demo.map.shortenMap': 'Karte niedriger machen',
  'demo.map.heightenMap': 'Karte höher machen',
  'demo.map.fitTitle': 'Position zurücksetzen + auf das Raster strecken',
  'demo.map.fit': 'Einpassen',
  'demo.map.lock': 'Sperren',
  'demo.map.adjust': 'Anpassen',
  'demo.map.fogOn': 'Nebel AN — zum Deaktivieren klicken',
  'demo.map.fogOff': 'Nebel AUS — zum Aktivieren klicken',
  'demo.map.fog': 'Nebel',
  'demo.map.exitPaintTitle': 'Malmodus verlassen',
  'demo.map.paintTitle': 'Nebel malen — Zellen klicken oder ziehen, um sie aufzudecken/zu verbergen',
  'demo.map.exitPaint': 'Malen beenden',
  'demo.map.paint': 'Malen',
  'demo.map.hexGridTitle': 'Hex-Raster — für Quadrat klicken',
  'demo.map.squareGridTitle': 'Quadratraster — für Hex klicken',
  'demo.map.hex': 'Hex',
  'demo.map.zoomOut': 'Verkleinern',
  'demo.map.zoomLevel': 'Zoomstufe',
  'demo.map.zoomIn': 'Vergrößern',
  'demo.map.resetView': 'Ansicht zurücksetzen',
  'demo.map.reset': 'Zurücksetzen',

  // ── DockPanel ───────────────────────────────────────────────────────────────
  'demo.dock.expand': '{title} ausklappen',
  'demo.dock.collapse': '{title} einklappen',

  // ── LeaveTableGuard ─────────────────────────────────────────────────────────
  'demo.leave.ariaLabel': 'Den Tisch verlassen?',
  'demo.leave.heading': 'Den Tisch verlassen?',
  'demo.leave.body':
    'Du steckst mitten im Spiel. Dies ist ein Gasttisch — wenn du jetzt gehst, endet die Sitzung und dein Held geht verloren.',
  'demo.leave.stay': 'Am Tisch bleiben',
  'demo.leave.leaveAnyway': 'Trotzdem verlassen',
}
